import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { FundPerformanceBackendService } from 'src/app/domain/fund-performance/service/fund-performance-backend.service';
import { InvestorReportService } from 'src/app/domain/investor-report/service/investor-report.service';
import { firstValueFrom } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: 'app-modal-delete-period',
  templateUrl: './modal-delete-period.component.html',
  styleUrls: ['./modal-delete-period.component.scss'],
})

/**
 * @var periodHasReport shows if @param selectedPeriod has a saved investor report {@link IrComponent}
 * if yes - shows disclaimer that investor report will be deleted with the period.
 */
export class ModalDeletePeriodComponent implements OnChanges, OnDestroy {
  private _destroyStream: Subject<void> = new Subject<void>();

  @Output() emitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() selectedPeriod: Date;
  @Input() selectedFundUuid: string;
  periodHasReport = false;
  showModalForDelete = false;
  modalButtons = {
    dismiss: 'Cancel',
    apply: 'Delete',
  };

  constructor(
    private fpService: FundPerformanceBackendService,
    private irService: InvestorReportService,
  ) { }

  ngOnChanges(): void {
    if (this.selectedPeriod && this.selectedFundUuid) {
      this.checkIfPeriodHasReport();
    }
  }

  async checkIfPeriodHasReport(): Promise<void> {
    this.periodHasReport = await firstValueFrom(this.irService.checkIfExists(this.selectedFundUuid, this.selectedPeriod.toString()).pipe(takeUntil(this._destroyStream)));
  }

  ngOnDestroy(): void {
    this._destroyStream.next();
    this._destroyStream.complete();
  }

  confirm(value: boolean): void {
    if (value) {
      this.confirmDeletingRoundByFundIdAndPeriod();
    } else {
      this.close(false);
    }
    this.showModalForDelete = false;
  }

  close(b: boolean): void {
    this.emitter.emit(b);
    this.ngOnDestroy();
  }

  async confirmDeletingRoundByFundIdAndPeriod(): Promise<void> {
    await firstValueFrom(this.fpService.delete(this.selectedFundUuid, this.selectedPeriod))
      .then(() => this.close(true));
  }
}
